<div class="modal-header">
  <h4 class="modal-title">Export Redemption Codes</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body pb-0">

  <div class="form-group">
    <label for="downloadFileNameInput">Download File Name</label>
    <input type="text" class="form-control" id="downloadFileNameInput" name="downloadFileName"
           [(ngModel)]="downloadFileName">
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary" type="button"
          *ngIf="!loadingSubmit"
          (click)="handleSubmit()">
    Export
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loadingSubmit">
    Loading...
  </button>
</div>
